import React, { useReducer, createContext } from 'react';
import Reducer from './reducer';
import { getValue } from '../common/data_storage';

const { location: { pathname = false } = false } = window;

const initialState = {
  User_Data: getValue('User_Data') || {},
  LangCode: getValue('LangCode') || 'EN',
  urlCustNum: pathname !== '/' && pathname.replaceAll('/', ''),
  logoImageUrl: getValue('logoImageUrl') || false,
  isAvailDBPaycheckData: false,
  isAvailDBPersonalsData: false,
  dashboardWidgetsList: {},
  isAvailNewsPage: true,
  buttonLoader: {
    login_loader: false,
    recover_loader: false,
    mfa_register_loader: false,
    mfa_validate_loader: false,
  },
};

export const context = createContext(initialState);

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <context.Provider value={{ state, dispatch }}>
      {children}
    </context.Provider>
  );
};

export default Store;